<template>
	<div class="w-full">
		<main class="constrained">
			<Instructions />
		</main>
	</div>
</template>
<script lang="ts">
import Instructions from '~/components/blocks/contractor/Instructions.vue';

definePageMeta({
  layout: 'basic-public',
})
export default defineComponent({
	components: {
		Instructions,
	},
  setup() {
    const { t } = useTranslation()

    return {
      t
    }
  },
	head () {
		return {
			title: `${ this.t('INSTRUCTIONS') } - ${this.t('CONTRACTOR_PORTAL')} - Glommen Mjøsen`,
		}
	},
})
</script>
